import { render } from "./AsyncImage.vue?vue&type=template&id=00273f24"
import script from "./AsyncImage.vue?vue&type=script&lang=js"
export * from "./AsyncImage.vue?vue&type=script&lang=js"

import "./AsyncImage.vue?vue&type=style&index=0&id=00273f24&lang=scss"
script.render = render

export default script